/**
 * Centralized access to Vite environment variables.
 *
 * Wrapping `import.meta.env` here gives tests one stable module boundary to
 * mock without coupling them to Vite's environment implementation.
 */

function withTrailingSlash(url: string | undefined): string | undefined {
  if (!url) return url;
  return url.endsWith("/") ? url : `${url}/`;
}

function withoutGraphqlPath(url: string | undefined): string {
  return (url ?? "http://localhost:3103/graphql")
    .replace(/\/graphql\/?$/, "")
    .replace(/\/$/, "");
}

export const env = {
  appVersion: import.meta.env.VITE_APP_VERSION,
  mode: import.meta.env.MODE,
  skedLinkBackendApiUrl: import.meta.env.VITE_SKED_LINK_BACKEND_API_URL,
  skedLinkBackendUrl: withoutGraphqlPath(
    import.meta.env.VITE_SKED_LINK_BACKEND_API_URL
  ),
  schedugramServerBackendUrl: withTrailingSlash(
    import.meta.env.VITE_SCHEDUGRAM_SERVER_BACKEND_URL
  ),
  skedLinkPublicDomain: import.meta.env.VITE_SKED_LINK_PUBLIC_DOMAIN,
  otelEnabled: import.meta.env.VITE_OTEL_ENABLED,
  otelSampleRate: import.meta.env.VITE_OTEL_SAMPLE_RATE,
  otelEndpoint: import.meta.env.VITE_OTEL_ENDPOINT,
  otelAuthHeader: import.meta.env.VITE_OTEL_AUTH_HEADER,
  otelOrg: import.meta.env.VITE_OTEL_ORG,
  otelStream: import.meta.env.VITE_OTEL_STREAM,
  rumClientToken: import.meta.env.VITE_RUM_CLIENT_TOKEN,
  rumOrg: import.meta.env.VITE_RUM_ORG,
  rumSessionSampleRate: import.meta.env.VITE_RUM_SESSION_SAMPLE_RATE,
  rumSessionReplaySampleRate: import.meta.env
    .VITE_RUM_SESSION_REPLAY_SAMPLE_RATE,
} as const;
